<template>
  <div>
    <div
      class="content product-detail course-invite"
      :class="{
        'h5-product-detail': isH5,
        'pc-product-detail': !isH5,
        'elec--product-detail': isElectron || isMGAppInPad,
        'H5-group-course-page': handleCourseCard.name === 'H5GroupCourse',
        'pad-app-product-detail': isMGAppInPad && isH5,
      }"
    >
      <div class="product-top">
        <!-- 概要信息 -->
        <component
          ref="courseCard"
          @jumpLoginPage="jumpLoginPage"
          :product-info="productInfo"
          :canTrialLseeon="canTrialLseeon"
          :isH5="isH5"
          :is="handleCourseCard.components"
        />
        <!-- tab -->
        <div class="tab-box">
          <div
            :class="{
              'tabs-fixed': detailNavFixed,
              'electron-tab-fixed': isElectron,
            }"
            :style="'top:' + tabFixTop + 'px'"
          >
            <ul class="tabs-wrap">
              <li
                v-for="item in sortTabListById"
                :key="item.id"
                :class="{
                  active: item.id === activeId,
                  'course-tab':
                    item.id === 2 &&
                    canTrial &&
                    productInfo.enrollment === null,
                }"
                @click="changeTab(item)"
              >
                {{ item.title }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="tabs-cont">
        <!-- 详情 -->
        <div class="tab-content ql-snow" ref="detail">
          <CourseDescription
            :isH5="isH5"
            :courseDescription="productInfo.course_description || ''"
          />
        </div>

        <!-- 课程 -->
        <div class="tab-content course-cont" ref="course">
          <div>
            <div class="lesson-list">
              <div class="course-card" v-if="!isH5 && false">
                <img
                  class="cover"
                  :src="productInfo.cover_url + '?imageView2/0/w/320'"
                  alt="课程图片"
                />
                <div class="lesson-info">
                  <p class="title">
                    {{ productInfo.course_name }}
                  </p>
                  <p class="lesson-num">
                    <span>{{ productInfo.lessonNum }}课时</span>
                    <span>
                      （{{ productInfo.liveNum }}直播，{{
                        productInfo.vidoeNum
                      }}点播，{{ productInfo.workNum }}作业）
                    </span>
                  </p>
                </div>
              </div>
              <component
                :is="handleLessonListCom"
                :isRegistered="productInfo.enrollment !== null"
                :unitList="productInfo.unit_list || []"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <button class="fix-bottom-wrap" @click="bindCourseStudent(true)">
        {{ this.bindSuccess ? "已绑定成功" : "立即绑定" }}
      </button>
    </div>
  </div>
</template>

<script>
import H5LessonList from "../product-details/lesson-list/H5LessonList";
import CourseDescription from "../product-details/components/CourseDescription";
import LessonList from "../product-details/lesson-list/LessonList.vue";
import CourseCard from "@saas/pages/src/product-details/course-card/CourseCard";
import {
  isH5,
  isHXApp,
  isWeChat,
  isWebPageInElectron,
  isMGAppInPad,
} from "@saas/components/src";
import { mapGetters } from "vuex";
import {
  getCourseInfo,
  bindCourseStudent,
} from "@saas/service-api/src/product-details";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import { EventBus } from "@saas/components/src/utils/event-bus";
import handleCourseInfo from "@saas/components/src/mixins/handleCourseInfo";
import { getUserInfo } from "@saas/service-api/src";
import types from "@saas/store/src/types.js";
import courseQuickBar from "@saas/components/src/mixins/courseQuickBar";
export default {
  mixins: [handleCourseInfo, courseQuickBar],
  data: function () {
    return {
      showBottomCountdown: false,
      isH5: isH5(),
      isHXApp: isHXApp(),
      isMGAppInPad: false,
      tabList: [
        { id: 1, title: "详情", ref: "detail", class: "ql-snow" },
        { id: 2, title: "课程", ref: "course", class: "course-cont" },
      ],
      activeId: 1,
      lastTime: 0,
      detailNavFixed: false,
      canShowAllInfo: false, // 是否可展开收起
      showAllStatus: false, // false:展开，true：收起
      productInfo: {}, // 商品信息-activity_type:1优惠券 2限时促销 3:联报 4:拼团
      loading: false, // 报名请求状态
      scrollLock: false, // 点击锚点锁定，不触发滚动内容对导航的影响
      timer: null,
      isChangeTab: false, // 点击tab和监听滚动-高亮tab冲突
      tabFixTop: 0, // tab定位top值(客户端会被topbar遮盖)
      isElectron: window.isElectron,
      isWebPageInElectron: isWebPageInElectron(),
      isWechat: isWeChat(),
    };
  },
  mounted() {
    this.isMGAppInPad = isMGAppInPad();
    this.isH5 = isH5();
    if (this.isHXApp) {
      jsToFlutter("getToken");
      EventBus.$off("setToken");
      EventBus.$on("setToken", (isLogin) => {
        // 获取页面信息
        this.apiGetCourseInfo();
      });
    } else if (this.isWebPageInElectron || this.isWechat) {
      getUserInfo().then((res) => {
        if (res.code === 1) {
          this.$store.commit(types.CHANGE_PROFILE, {
            profile: res.data,
          });
        }
      });
      this.apiGetCourseInfo();
    } else {
      this.apiGetCourseInfo();
    }
    this.$nextTick(() => {
      setTimeout(() => {
        if (window.isElectron) {
          let elMain = document.getElementById("electron-main");
          if (!elMain) return;
          elMain.addEventListener("scroll", this.scrollFunc, true);
          elMain.addEventListener("scroll", this.scrollActiveNav, true);
        } else {
          window.addEventListener("scroll", this.scrollFunc, true);
          window.addEventListener("scroll", this.scrollActiveNav, true);
        }
        if (this.$refs["detail"]) {
          this.canShowAllInfo = this.$refs["detail"].offsetHeight > 4000;
        }
      }, 0);
    });
  },
  destroyed() {
    //取消监听滚动置顶
    if (window.isElectron) {
      let elMain = document.getElementById("electron-main");
      if (!elMain) return;
      elMain.removeEventListener("scroll", this.scrollFunc, true);
      elMain.removeEventListener("scroll", this.scrollActiveNav, true);
    } else {
      window.removeEventListener("scroll", this.scrollFunc, true);
      window.removeEventListener("scroll", this.scrollActiveNav, true);
    }

    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    scrollActiveNav(e) {
      if (this.isChangeTab) return;
      const scrollItems = document.querySelectorAll(".tab-content");
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.scrollLock) {
        this.timer = setTimeout(() => {
          this.scrollLock = false;
        }, 35);
        return;
      }
      for (let i = this.tabList.length - 1; i >= 0; i--) {
        var scrollTop =
          document.body.scrollTop ||
          document.documentElement.scrollTop ||
          e.target.scrollTop;
        if (scrollItems[i]?.offsetTop) {
          const judge = scrollTop >= scrollItems[i].offsetTop - 136;
          if (judge) {
            this.activeId = this.tabList[i].id;
            break;
          }
        }
      }
    },
    apiGetCourseInfo() {
      let course_id = this.$route.params.id;
      if (!course_id) return;
      getCourseInfo({ course_id }).then((res) => {
        if (res.code === 1) {
          if (res.data) {
            this.localSavePage(res.data);
            // 设置页面标题
            if (res.data?.course_name) {
              let title = res.data.course_name;
              document.title = title;
              jsToFlutter("setTitle", { title });
            }
            // 计算课时数-直播课状态处理
            this.productInfo = this.handleCourseInfoData(res.data || {});
          }
          this.bindCourseStudent();
        } else if (res.code === 4444) {
          this.$showErrorPage();
        } else if (res.code === 6666) {
          this.$showErrorPage({
            tips: "课程不存在",
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    jumpLoginPage() {
      if (this.isHXApp) {
        jsToFlutter("login");
        console.log("jsToFlutter===login-product-detail");
      } else {
        this.$loginDialog();
      }
    },
    changeTab(item) {
      this.isChangeTab = true;
      this.activeId = item.id;
      if (this.$refs[item.ref]) {
        this.$refs[item.ref].scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      setTimeout(() => {
        this.isChangeTab = false;
      }, 2000);
    },
    // 滚动置顶
    scrollFunc(e) {
      var nowTime = Date.now();
      if (nowTime - this.lastTime) {
        this.lastTime = nowTime;
        // 导航
        if (document.querySelector(".topbar")) {
          // 客户端
          let height = document.querySelector(".topbar").offsetHeight;
          this.tabFixTop = height;
        } else if (document.querySelector(".nav-bar")) {
          // web
          let height = document.querySelector(".nav-bar").offsetHeight;
          this.tabFixTop = height;
        }
        let courseTopHeight =
          document.querySelector(".product-top")?.offsetHeight || 0;
        let courseTopOffsetTop =
          document.querySelector(".product-top")?.offsetTop || 0;

        const scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          e.target.scrollTop;
        this.detailNavFixed = scrollTop >= courseTopHeight + courseTopOffsetTop;

        // 底部倒计时
        let groupEl = document.getElementById("activity-group");
        if (this.productInfo.enrollment !== null || !groupEl) {
          return false;
        }
        let { offsetTop, offsetHeight } = groupEl;
        let top = offsetTop + offsetHeight;
        let coverHeight = document.querySelector("#h5-course-cover");
        if (isH5 && coverHeight) {
          top += coverHeight.offsetHeight;
        }
        if (scrollTop >= top) {
          this.showBottomCountdown = true;
        } else {
          this.showBottomCountdown = false;
        }
      }
    },
    async bindCourseStudent(flag = false) {
      console.log(
        "bindSuccess",
        this.bindSuccess,
        "isAuthenticated",
        this.isAuthenticated,
        "enrollment",
        this.productInfo.enrollment,
        "user",
        this.user
      );
      if (this.bindSuccess) return;
      if (!this.isAuthenticated && flag) {
        this.jumpLoginPage();
        return;
      }
      if (
        !this.isAuthenticated ||
        !this.productInfo ||
        this.productInfo.enrollment
      )
        return;
      const res = await bindCourseStudent({
        course_id: this.productInfo.id,
      });

      if (res.code === 1) {
        this.$message.success("绑定成功");
        this.apiGetCourseInfo();
      } else if (res.code === 10009) {
        this.jumpLoginPage();
      } else {
        this.$message.error(res.message);
        await this.$store.dispatch("user/logout");
        await this.$store.dispatch("user/getInfo");
      }
    },
  },
  watch: {
    isAuthenticated(newVal) {
      if (newVal) {
        this.bindCourseStudent();
      }
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated", "user"]),
    sortTabListById() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.tabList.sort((a, b) => {
        return a.id - b.id;
      });
    },
    handleCourseCard() {
      return {
        name: "CourseCard",
        components: CourseCard,
      };
    },
    handleLessonListCom() {
      if (this.isH5) {
        return H5LessonList;
      } else {
        return LessonList;
      }
    },
    bindSuccess() {
      return (
        this.productInfo &&
        this.productInfo.enrollment !== null &&
        this.isAuthenticated
      );
    },
  },
  components: {
    CourseDescription,
    CourseCard,
    LessonList,
    H5LessonList,
  },
};
</script>

<style lang="scss" scoped>
.pc-product-detail {
  padding-top: 20px;
  max-width: 800px;
  width: 100%;
  padding-bottom: 140px;
  // 推荐课程
  .tab-content.recommend-cont {
    background: transparent;
    ::v-deep .pc-course-card {
      width: 262px;
      height: 310px;
      margin-right: 7px;
      padding: 12px 8px 16px;
      .cover-wrap {
        width: 100%;
        height: 138px;
      }
      .price-size-wrap {
        .active-price {
          font-size: 20px;
        }
        .unit,
        .decimal {
          font-size: 16px;
        }
      }
    }
    .pc-course-card:nth-child(3n) {
      margin-right: 0;
    }
  }
  .recommend-title {
    font-weight: 600;
    font-size: 30px;
    color: #0d1400;
    line-height: 42px;
    margin: 20px 0;
  }
  .recommend-course-wrap {
    width: 880px;
    display: flex;
    flex-wrap: wrap;
    .course-card {
      margin-right: 7px;
    }
  }
  .product-top {
    position: relative;
    z-index: 2;
  }
  .tab-box {
    height: 63px;
  }
  .ql-snow,
  .course-cont,
  .comment-cont,
  .recommend-cont {
    padding-top: 70px;
    margin-top: -70px;
    background: transparent !important;
  }
  .tabs-cont {
    padding-top: 70px;
    margin-top: -70px;
    background: #fff;
    padding-bottom: 15px;
    border-radius: 0 0 24px 24px;
    // overflow: hidden;
  }
  .go-back-wrap {
    padding: 14px 8px;
    display: flex;
    align-items: center;
    font-size: 14px;
    width: fit-content;
    cursor: pointer;
    img {
      width: 22px;
      height: 22px;
    }
    span {
      margin-left: 10px;
    }
  }
  .basic-info {
    border-radius: 8px 8px 0 0;
    background: #fff;
    padding: 20px;
    display: flex;
    .cover {
      width: 320px;
      height: 180px;
      margin-right: 8px;
      object-fit: cover;
    }
    .info-wrap {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      .title {
        font-size: 18px;
        line-height: 25px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        margin-bottom: 8px;
        word-break: break-all;
      }
      .validity-period {
        font-size: 12px;
        line-height: 17px;
        color: $chiral-light-text-color;
      }
      .activity-price-wrap {
        background: url("../../assets/images/activity-bg.png");
        background-size: 100% 100%;
      }
      .price-wrap {
        width: 372px;
        height: 58px;
        padding: 0 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        .left-wrap {
          display: flex;
          align-items: center;
        }
        .price {
          font-weight: 500;
          font-size: 18px;
          color: $chiral-price-color;
          line-height: 25px;
          margin-right: 40px;
        }
        .price.activity-price {
          color: $activity-color;
        }
        .STATS {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 16px;
          .num {
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            margin-bottom: 2px;
          }
          .text {
            font-weight: 400;
            font-size: 12px;
            color: $chiral-light-text-color;
            line-height: 17px;
          }
        }
        .course-card-btn {
          width: 88px;
          height: 32px;
          border-radius: 17px;
          font-size: 14px;
          padding: 0;
          line-height: 32px;
        }
      }
    }
  }
  .tabs-wrap {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 17px 34px;
    font-weight: 400;
    font-size: 16px;
    color: $plain-text-color;
    line-height: 22px;
    li {
      cursor: pointer;
      margin-right: 40px;
      padding-bottom: 7px;
    }
    .course-tab {
      position: relative;
      &::after {
        position: absolute;
        content: "免费试学";
        display: block;
        left: 50%;
        top: 28px;
        transform: translateX(-50%);
        width: 50px;
        height: 18px;
        font-weight: 600;
        font-size: 10px;
        color: #ffffff;
        line-height: 1;
        color: #ffffff;
        background: url("../../assets/images/product-details/try-tag.png");
        background-size: 100% 100%;
        text-align: center;
        padding-top: 5px;
      }
    }
    .active {
      position: relative;
      font-weight: 600;
      font-size: 16px;
      color: $saas-text-color;
      line-height: 22px;
      &::after {
        position: absolute;
        content: " ";
        display: block;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 16px;
        height: 3px;
        background: linear-gradient(
          132deg,
          $linear-gradient-begin 0%,
          $linear-gradient-end 100%
        );
        border-radius: 2px;
      }
    }
  }
  .tabs-fixed {
    position: fixed;
    width: 100%;
    z-index: 2;
    background: #ffffff;
    box-shadow: 0px 6px 16px 0px rgba(102, 116, 107, 0.1);
    left: 0;
    top: 0;
    .tabs-wrap {
      width: 100%;
      padding: 23px 28px 12px;
      max-width: 800px;
      margin: 0 auto;
    }
    li {
      padding-bottom: 11px;
    }
    .course-tab:not(.active) {
      position: relative;
      &::after {
        display: none !important;
      }
    }
  }
  .tab-content {
    background: #fff;
  }
  .course-cont > div {
    background: #fff;
    padding-bottom: 2px;
  }
  .ql-snow > div {
    background: #fff;
    padding: 0 16px 24px;
  }
  .product-info-wrap {
    max-height: 4000px;
    overflow: hidden;
  }
  .show-all {
    max-height: none;
  }
  .show-all-info {
    font-size: 14px;
    text-align: center;
    padding-top: 10px;
    span {
      cursor: pointer;
    }
    i {
      margin-left: 10px;
    }
  }
  .lesson-list {
    padding: 0 18px;
  }
  .tab-title {
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 25px;
    margin-bottom: 24px;
  }
  // .course-card {
  //   display: flex;
  //   align-items: center;
  //   border-radius: 8px;
  //   background: #fff;
  //   padding: 10px;
  //   border: 1px solid #ebebeb;
  //   box-shadow: 0 5px 11px rgba(163, 163, 163, 0.0588235294);
  //   margin-bottom: 20px;
  //   .cover {
  //     width: 160px;
  //     height: 90px;
  //     margin-right: 15px;
  //     object-fit: cover;
  //   }
  //   .lesson-info {
  //     flex: 1;
  //     width: 0;
  //   }
  //   .title {
  //     font-size: 16px;
  //     font-weight: 600;
  //     white-space: nowrap;
  //     overflow: hidden;
  //     text-overflow: ellipsis;
  //     margin-bottom: 15px;
  //   }
  //   .lesson-num {
  //     color: #95a1af;
  //   }
  // }

  .left-wrap {
    margin-right: 37px;
  }
  .price {
    font-weight: 600;
    font-size: 16px;
    color: $chiral-price-color;
    line-height: 22px;
  }
}

// 适配样式
.h5-product-detail {
  width: 100%;
  background: #fff;
  font-size: 0.37rem;
  padding-bottom: 2.35rem;
  min-height: 100vh;
  margin-top: 0.25rem;
  .go-back-wrap {
    display: flex;
    align-items: center;
    padding: 0.27rem 0.21rem;
    font-size: 0.3733rem;
    width: fit-content;
    img {
      width: 0.53rem;
      height: 0.53rem;
    }
    span {
      margin-left: 0.13rem;
    }
  }
  .tab-box {
    height: 0.72rem;
  }
  // 解决scrollview被吸顶部分遮盖问题
  .ql-snow,
  .course-cont,
  .comment-cont {
    padding-top: calc(1.07rem + #{$h5-open-app-height});
    margin-top: calc(-1.07rem - #{$h5-open-app-height});
    background: transparent !important;
  }

  // tab
  .tabs-wrap {
    background: #fff;
    display: flex;
    align-items: center;
    padding: 0 0 0.1rem 0.45rem;
    li {
      font-weight: 400;
      font-size: 0.37rem;
      color: #515350;
      line-height: 0.53rem;
      padding-bottom: 0.08rem;
      margin-right: 0.59rem;
      cursor: pointer;
    }
    .active {
      position: relative;
      font-weight: 600;
      color: $saas-text-color;
      &::after {
        position: absolute;
        content: " ";
        display: block;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 0.21rem;
        height: 0.05rem;
        border-radius: 0.03rem;
        background: linear-gradient(
          132deg,
          $linear-gradient-begin 0%,
          $linear-gradient-end 100%
        );
      }
    }
  }
  .tabs-fixed {
    position: fixed;
    width: 100vw;
    z-index: 2;
    background: #ffffff;
    box-shadow: 0rem 0.08rem 0.21rem 0rem rgba(102, 116, 107, 0.1);
    left: 0;
    top: 0 !important;
    .tabs-wrap {
      width: 100%;
      padding: 0.32rem 0 0.27rem 0.45rem;
      max-width: 100%;
      margin: 0 auto;
    }
  }

  .tab-content {
    background: #fff;
  }
  .course-cont > div {
    background: #fff;
    padding-bottom: 0.32rem;
  }
  .ql-snow > div {
    background: #fff;
    padding-bottom: 0.32rem;
  }
  .product-info-wrap {
    max-height: 4000px;
    overflow: hidden;
  }
  .show-all {
    max-height: none;
  }
  .show-all-info {
    text-align: center;
    font-size: 0.37rem;
    line-height: 0.53rem;
    padding: 0.43rem 0;
    i {
      margin-left: 0.25rem;
    }
  }
  .tab-title {
    font-weight: 600;
    font-size: 0.48rem;
    padding: 0.21rem;
  }
}

//electron
.electron-tab-fixed.tabs-fixed {
  width: calc(100% - #{$side-bar-width}) !important;
  left: $side-bar-width !important;
}
#electron-main {
  // 推荐课程
  .tab-content.recommend-cont {
    ::v-deep .electron-course-card {
      width: 250px;
      height: 262px;
      margin-right: 25px;
      .cover-wrap {
        width: 100%;
        height: 130px;
      }
    }
    .electron-course-card:nth-child(3n) {
      margin-right: 0;
    }
  }
  .ql-snow,
  .course-cont,
  .comment-cont,
  .recommend-cont {
    padding-top: 130px;
    margin-top: -130px;
    background: transparent !important;
  }
  .tabs-cont {
    padding-top: 130px;
    margin-top: -130px;
  }
  .course-tab::after {
    top: 22px !important;
  }
}

// 活动按钮样式
.activity-sign-up-btn {
  background: $activity-color;
  border-color: $activity-color;
}
.activity-sign-up-btn.el-button:hover,
.activity-sign-up-btn.el-button:focus {
  background: $activity-color !important;
  border-color: $activity-color !important;
  color: #fff;
}
</style>
<style lang="scss">
.course-invite {
  .share-icon,
  .price-wrap {
    display: none;
  }
  .fix-bottom-wrap {
    position: fixed;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    height: 50px;
    background: linear-gradient(132deg, #00eb81, #00c89d);
    width: 90%;
    max-width: 500px;
    border-radius: 24px;
    box-shadow: 0px -6px 16px 0px rgba(102, 116, 107, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    border: none;
    cursor: pointer;
  }
}
</style>
<style>
.product-title-tooltip {
  max-width: 300px;
}
@media (max-width: 767px) {
  .product-title-tooltip {
    max-width: 90%;
  }
}
</style>
